// Golf BPM — Swing Timing Calculator Widget
// All functions are prefixed with "tc" and scoped inside an IIFE to avoid
// conflicts with landing.js. The applyTheme function sets CSS variables on
// the .tc-section element so the widget's color theme is self-contained.

(function () {
  'use strict';

  // ===========================================================================
  // DATA
  // ===========================================================================

  var DATA = {
    full: {
      label: 'Driver – 5 Iron',
      ratio: '3:1',
      color:       '#8bc34a',
      colorDark:   '#4a7a1e',
      colorLight:  'rgba(139,195,74,0.12)',
      colorBorder: 'rgba(139,195,74,0.30)',
      defaultBpm: 144,
      phaseLabels: ['Backswing', 'Downswing', 'Total Swing'],
      tempos: [
        { bpm: 126, back: 1.01, down: 0.34, total: 1.34, pros: 'Collin Morikawa · Sungjae Im' },
        { bpm: 144, back: 0.90, down: 0.30, total: 1.20, pros: 'Justin Thomas · Cam Young' },
        { bpm: 156, back: 0.84, down: 0.28, total: 1.12, pros: 'Scottie Scheffler · Rory McIlroy' },
        { bpm: 184, back: 0.69, down: 0.23, total: 0.92, pros: 'Bryson DeChambeau · Jon Rahm' }
      ]
    },
    mid: {
      label: '6 Iron – P Wedge',
      ratio: '2.5:1',
      color:       '#f59e0b',
      colorDark:   '#b37800',
      colorLight:  'rgba(245,158,11,0.12)',
      colorBorder: 'rgba(245,158,11,0.35)',
      defaultBpm: 144,
      phaseLabels: ['Backswing', 'Downswing', 'Total Swing'],
      tempos: [
        { bpm: 126, back: 0.64, down: 0.26, total: 0.90, pros: 'Collin Morikawa · Sungjae Im' },
        { bpm: 144, back: 0.59, down: 0.24, total: 0.83, pros: 'Justin Thomas · Cam Young' },
        { bpm: 156, back: 0.56, down: 0.22, total: 0.78, pros: 'Scottie Scheffler · Rory McIlroy' },
        { bpm: 184, back: 0.50, down: 0.20, total: 0.70, pros: 'Bryson DeChambeau · Jon Rahm' }
      ]
    },
    short: {
      label: 'Chipping & Putting',
      ratio: '2:1',
      color:       '#f43f5e',
      colorDark:   '#be123c',
      colorLight:  'rgba(244,63,94,0.12)',
      colorBorder: 'rgba(244,63,94,0.30)',
      defaultBpm: 135,
      phaseLabels: ['Back Stroke', 'Through Stroke', 'Total Stroke'],
      tempos: [
        { bpm: 131, back: 0.55, down: 0.27, total: 0.82, pros: '' },
        { bpm: 135, back: 0.53, down: 0.26, total: 0.79, pros: '' },
        { bpm: 138, back: 0.51, down: 0.25, total: 0.76, pros: '' }
      ]
    }
  };

  // ===========================================================================
  // STATE
  // ===========================================================================

  var tcActiveClub = 'full';
  var tcActiveBpm  = 144;

  // ===========================================================================
  // THEME — sets CSS variables on the section element so they're self-contained
  // ===========================================================================

  function tcApplyTheme(club) {
    var d    = DATA[club];
    var root = document.querySelector('.tc-section');
    if (!root) return;
    root.style.setProperty('--accent',        d.color);
    root.style.setProperty('--accent-dark',   d.colorDark);
    root.style.setProperty('--accent-light',  d.colorLight);
    root.style.setProperty('--accent-border', d.colorBorder);
  }

  // ===========================================================================
  // BUILD BPM PILLS
  // ===========================================================================

  function tcBuildBpmPills(club) {
    var d         = DATA[club];
    var container = document.getElementById('tc-bpm-pills');
    if (!container) return;
    container.innerHTML = '';
    d.tempos.forEach(function (t) {
      var btn = document.createElement('button');
      btn.className   = 'bpm-btn' + (t.bpm === tcActiveBpm ? ' active' : '');
      btn.textContent = t.bpm;
      btn.onclick     = function () { tcSelectBpm(t.bpm, btn); };
      container.appendChild(btn);
    });
  }

  // ===========================================================================
  // UPDATE DISPLAY
  // ===========================================================================

  function tcUpdateDisplay(animate) {
    var d   = DATA[tcActiveClub];
    var row = null;
    for (var i = 0; i < d.tempos.length; i++) {
      if (d.tempos[i].bpm === tcActiveBpm) { row = d.tempos[i]; break; }
    }
    if (!row) row = d.tempos[0];

    var backPct = Math.round((row.back / row.total) * 100);

    var donut = document.getElementById('tc-donut');
    if (donut) {
      donut.style.background =
        'conic-gradient(' + d.color + ' 0% ' + backPct + '%, ' +
        d.colorDark + ' ' + backPct + '% 100%)';
    }

    var donutRatio = document.getElementById('tc-donut-ratio');
    if (donutRatio) {
      donutRatio.textContent  = d.ratio;
      donutRatio.style.fontSize = d.ratio.length > 3 ? '20px' : '26px';
    }

    var dotBack = document.getElementById('tc-dot-back');
    if (dotBack) dotBack.style.background = d.color;

    var dotDown = document.getElementById('tc-dot-down');
    if (dotDown) dotDown.style.background = d.colorDark;

    var labelBack  = document.getElementById('tc-label-back');
    var labelDown  = document.getElementById('tc-label-down');
    var labelTotal = document.getElementById('tc-label-total');
    if (labelBack)  labelBack.textContent  = d.phaseLabels[0];
    if (labelDown)  labelDown.textContent  = d.phaseLabels[1];
    if (labelTotal) labelTotal.textContent = d.phaseLabels[2];

    var animIds = ['tc-val-back', 'tc-val-down', 'tc-val-total', 'tc-pros-names'];

    if (animate) {
      animIds.forEach(function (id) {
        var el = document.getElementById(id);
        if (el) el.classList.add('updating');
      });
      setTimeout(function () {
        tcSetValues(row);
        animIds.forEach(function (id) {
          var el = document.getElementById(id);
          if (el) el.classList.remove('updating');
        });
      }, 150);
    } else {
      tcSetValues(row);
    }

    var prosCard = document.getElementById('tc-pros-card');
    if (prosCard) prosCard.style.display = tcActiveClub === 'short' ? 'none' : 'flex';
  }

  function tcSetValues(row) {
    var vb = document.getElementById('tc-val-back');
    var vd = document.getElementById('tc-val-down');
    var vt = document.getElementById('tc-val-total');
    var pn = document.getElementById('tc-pros-names');
    if (vb) vb.textContent = row.back.toFixed(2)  + ' sec';
    if (vd) vd.textContent = row.down.toFixed(2)  + ' sec';
    if (vt) vt.textContent = row.total.toFixed(2) + ' sec';
    if (pn) pn.textContent = row.pros;
  }

  // ===========================================================================
  // INTERACTIONS — exposed on window so inline onclick attributes can call them
  // ===========================================================================

  window.tcSelectClub = function (club, btn) {
    document.querySelectorAll('.tc-section .club-btn').forEach(function (b) {
      b.classList.remove('active');
    });
    btn.classList.add('active');
    tcActiveClub = club;
    tcActiveBpm  = DATA[club].defaultBpm;
    tcApplyTheme(club);
    tcBuildBpmPills(club);
    tcUpdateDisplay(false);
  };

  function tcSelectBpm(bpm, btn) {
    document.querySelectorAll('#tc-bpm-pills .bpm-btn').forEach(function (b) {
      b.classList.remove('active');
    });
    btn.classList.add('active');
    tcActiveBpm = bpm;
    tcUpdateDisplay(true);
  }

  // ===========================================================================
  // INIT
  // ===========================================================================

  document.addEventListener('DOMContentLoaded', function () {
    tcApplyTheme(tcActiveClub);
    tcBuildBpmPills(tcActiveClub);
    tcUpdateDisplay(false);
  });

}());
